module.exports = __webpack_public_path__ + "img/sm-164906089200720220217072838.450b4994.jpg";